import { Injectable, inject } from '@angular/core';
import { PRIVILEGE_CONDITIONS, } from '@qts-sdp-ui/shared-data';
import { BehaviorSubject, Subscription, finalize, map, shareReplay, } from 'rxjs';
import { ApiService } from './api.service';
import * as i0 from "@angular/core";
export class UserService {
    constructor() {
        this.subscriptionHolder = new Subscription();
        this.apiService = inject(ApiService);
        /**
         * @deprecated This should not be used; Use userContextSubject or userInfoSubject or qUserDataSubject instead.
         */
        this.userSubject = new BehaviorSubject(undefined);
        /**
         * @deprecated This should not be used; Use userContext$ or userInfo$ or qUserData$ instead.
         */
        this.user$ = this.userSubject.asObservable();
        this.userContextSubject = new BehaviorSubject(undefined);
        this.userInfoSubject = new BehaviorSubject(undefined);
        this.qUserDataSubject = new BehaviorSubject(undefined);
        this.userContext$ = this.userContextSubject.asObservable();
        this.userInfo$ = this.userInfoSubject.asObservable();
        this.qUserData$ = this.qUserDataSubject.asObservable();
        this.userData = null;
        this.isLoading = true;
    }
    //#region LifeCycle
    ngOnDestroy() {
        this.subscriptionHolder.unsubscribe();
    }
    //#endregion
    get userContext() {
        return this.userData?.userContext ?? null;
    }
    get isEmployee() {
        return this.userContext?.employee ?? false;
    }
    get isCustomer() {
        return this.userContext?.customer ?? false;
    }
    get isDemoUser() {
        return this.userContext?.demoUser ?? false;
    }
    get userName() {
        return this.userContext?.name ?? '';
    }
    get userInfo() {
        return this.userData?.userInfo ?? null;
    }
    get qUserData() {
        return this.userData?.q_userdata ?? null;
    }
    get user_cpy_sites() {
        return this.qUserData?.cpy_sites ?? '';
    }
    get userCpyId() {
        return this.qUserData?.cpy_id ?? '';
    }
    get userClientId() {
        return this.userInfo?.client?.id ?? '';
    }
    get userCpyName() {
        return this.qUserData?.cpy_name ?? '';
    }
    hasPrivilege(privilegeName) {
        return (-1 !==
            this.userContext?.privileges?.findIndex((item) => item === privilegeName));
    }
    checkTabPrivilege(privilegesConfig) {
        const { privileges, condition, employeeOnly, customersOnly, enableForDemoUser = true, } = privilegesConfig;
        if (!this.userContext?.privileges?.length ||
            (employeeOnly && !this.isEmployee) ||
            (customersOnly && this.isEmployee) ||
            (!enableForDemoUser && this.isDemoUser)) {
            return false;
        }
        if (privileges) {
            let hasPrivilege = false;
            if (condition == PRIVILEGE_CONDITIONS.AND) {
                hasPrivilege = privileges.every((ai) => this.userContext?.privileges?.includes(ai));
            }
            else {
                hasPrivilege = privileges.some((ai) => this.userContext?.privileges?.includes(ai));
            }
            return hasPrivilege;
        }
        /**
         * Temp
         * - Ideally this should be false ie. Atleast one privilege must exist for employee / user
         * - Currently previlages is not add to currectly for all tabs.
         */
        return true;
    }
    hasAnyPrivilege(...privilegeNames) {
        return (this.userContext?.privileges?.some((item) => privilegeNames.indexOf(item) !== -1) ?? false);
    }
    hasAllPrivileges(...privilegeNames) {
        return privilegeNames.every((privilege) => this.hasPrivilege(privilege));
    }
    /**
     * @deprecated Please use loadUserContext, loadUserInfo or loadQualtricsUserData instead
     */
    loadUserData() {
        this.loadUserContext();
    }
    loadUserContext() {
        this.subscriptionHolder.add(this.apiService
            .getUserContext()
            .pipe(map((responseData) => ({
            userContext: responseData,
        })), finalize(() => {
            this.isLoading = false;
        }), shareReplay())
            .subscribe((userData) => {
            this.userData = {
                ...this.userData,
                userContext: userData.userContext,
            };
            this.userSubject.next(userData);
            this.userContextSubject.next(userData.userContext);
        }));
    }
    loadUserInfo() {
        this.subscriptionHolder.add(this.apiService
            .getUserInfo()
            .pipe(shareReplay())
            .subscribe((userInfo) => {
            this.userData = {
                userContext: {},
                ...this.userData,
                userInfo,
            };
            this.userInfoSubject.next(userInfo);
        }));
    }
    loadQualtricsUserData() {
        this.subscriptionHolder.add(this.apiService
            .getAuxiliaryQualtricsUserData()
            .pipe(shareReplay())
            .subscribe((q_userdata) => {
            this.userData = {
                userContext: {},
                ...this.userData,
                q_userdata,
            };
            this.qUserDataSubject.next(q_userdata);
        }));
    }
    static { this.ɵfac = function UserService_Factory(t) { return new (t || UserService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: UserService, factory: UserService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], null, null); })();
